import * as React from "react";
import ReactModal from "react-modal";
import { RemoveScroll } from "react-remove-scroll";
import theme from "themes/simple-theme";

interface IProps {
  contentLabel?: string;
  children?: any;
  large?: boolean;
  className?: string;
  isOpen: boolean;
  closeTimeoutMS?: number;
  maxWidth?: number | string;
  maxHeight?: number | string;
  smallPadding?: boolean;
  onAfterOpen?(): void;
  onRequestClose?(event: React.MouseEvent | React.KeyboardEvent): void;
}

ReactModal.setAppElement("body");

const Modal = ({
  isOpen = false,
  onAfterOpen,
  onRequestClose,
  contentLabel,
  maxHeight,
  maxWidth,
  closeTimeoutMS = 250,
  large = false,
  smallPadding = false,
  children
}: IProps) => {
  const modalStyles = {
    overlay: { backgroundColor: theme.color.secondaryTransparent },
    content: {
      top: "15%",
      bottom: "none",

      maxWidth: maxWidth ? maxWidth : large ? 700 : 330,
      maxHeight: maxHeight ? maxHeight : "100%",
      marginLeft: "auto",
      lineHeight: 1.45,
      marginRight: "auto",
      padding: smallPadding ? "20px 30px" : "50px 80px 30px 80px",
      border: "none",
      boxShadow: "0px 3px 15px rgba(0, 0, 0, 0.15)",
      borderRadius: 0
    }
  };
  const preventIOSScroll = e => {
    e.preventDefault();
  };
  // TODO: WIP callbacks to fix modal scrolling in iOS
  const handleOnAfterOpen = () => {
    document.documentElement.style.overflowY = "hidden";
    document.documentElement.addEventListener("touchmove", preventIOSScroll);
    if (onAfterOpen) {
      onAfterOpen();
    }
  };
  const handleOnRequestClose = (
    event: React.MouseEvent | React.KeyboardEvent
  ) => {
    document.documentElement.style.overflowY = "visible";
    document.documentElement.removeEventListener("touchmove", preventIOSScroll);
    if (onRequestClose) {
      onRequestClose(event);
    }
  };

  return (
    <RemoveScroll>
      <ReactModal
        isOpen={isOpen}
        onAfterOpen={onAfterOpen}
        onRequestClose={onRequestClose}
        contentLabel={contentLabel}
        closeTimeoutMS={closeTimeoutMS}
        style={modalStyles}
      >
        {children}
      </ReactModal>
    </RemoveScroll>
  );
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/common/Modal/Modal.tsx